const style = {
    chatContainer: {
        width: "100%",
        height: "calc(100vh - 90px)",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        background: "#181a20",
    },
    chatHeader: {
        width: "100%",
        height: "70px",
        background: "#1e212b",
        display: "flex",
        justifyContent: "space-between",
        padding: "0 25px",
        boxSizing: "border-box",
        alignItems: "center",
        flexShrink: 0,
    },
    clientInfo: {
        display: "flex",
        alignItems: "center",
        gap: "15px",
        cursor: "pointer",
    },
    clientPictureBox: {
        width: 45,
        height: 45,
        overflow: "hidden",
        borderRadius: "50%",
    },
    clientPicture: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    clientTextInfo: {
        display: "flex",
        flexDirection: "column",
        alignItems: "start"
    },
    clientName: {
        fontSize: "16px",
        color: "#FFF",
        fontWeight: "600",
    },
    clientNumber: {
        fontSize: "13px",
        color: "#aeb9c4",
    },
    chatOptionMenu: {
        display: "flex",
        gap: "10px"
    },
    headerButton: {
        background: "none",
        border: "none",
        color: "#aeb9c4",
        cursor: "pointer",
        padding: "8px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    chatBody: {
        flexGrow: 1,
        boxSizing: "border-box",
        overflowY: "auto",
        padding: "20px 30px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
    },
    noMessageInfo: {
        textAlign: "center",
        color: "#aeb9c4",
        marginTop: "auto",
        marginBottom: "auto",
    },
    sendMessagesBox: {
        width: "100%",
        height: "70px",
        background: "#1e212b",
        display: "flex",
        padding: "0 15px",
        boxSizing: "border-box",
        alignItems: "center",
        gap: "15px",
        flexShrink: 0,
    },
    messageInputBox: {
        flexGrow: 1,
    },
    messageInput: {
        width: "100%",
        height: "45px",
        background: "#2a2f3b",
        border: "1px solid #3c4257",
        borderRadius: "12px",
        padding: "0 20px",
        boxSizing: "border-box",
        fontSize: "15px",
        color: "#FFF",
        outline: "none",
    },
    iconButton: {
        background: "none",
        border: "none",
        color: "#aeb9c4",
        cursor: "pointer",
        padding: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
    },
    noChatContainer: {
        width: "100%",
        height: "calc(100vh - 90px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#181a20",
        color: "#aeb9c4",
        textAlign: "center",
    },
    noChatImage: {
        width: "250px",
        opacity: "0.5",
    },
    noChatTitle: {
        fontSize: "22px",
        color: "#FFF",
        marginTop: "30px",
        fontWeight: "600",
    },
    noChatSubtitle: {
        fontSize: "16px",
        marginTop: "10px",
    },
    warningBox: {
        width: "100%",
        height: "70px",
        background: "#1e212b",
        borderTop: "1px solid #4a412a",
        display: "flex",
        padding: "0 25px",
        boxSizing: "border-box",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        flexShrink: 0,
        color: "#f39c12",
        fontSize: "14px",
        textAlign: "center",
    },
    learnMoreLink: {
        background: 'none',
        border: 'none',
        color: '#3498db',
        textDecoration: 'underline',
        cursor: 'pointer',
        fontSize: '13px',
        marginLeft: '8px',
        padding: 0,
        fontWeight: '500'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    modalContent: {
        background: '#1e212b',
        padding: '25px 30px',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '500px',
        border: '1px solid #3c4257',
        color: '#aeb9c4',
        boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
    },
    modalHeader: {
        fontSize: '18px',
        color: '#FFF',
        fontWeight: '600',
        margin: '0 0 15px 0',
        paddingBottom: '15px',
        borderBottom: '1px solid #3c4257',
    },
    modalBody: {
        fontSize: '15px',
        lineHeight: '1.6',
    },
    modalFooter: {
        marginTop: '25px',
        textAlign: 'right',
    },
    modalCloseButton: {
        background: '#3498db',
        color: '#FFF',
        border: 'none',
        borderRadius: '8px',
        padding: '10px 20px',
        fontSize: '15px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'background 0.2s'
    },
    modalList: {
        listStyle: 'none',
        paddingLeft: '5px',
        margin: '15px 0',
    },
    modalListItem: {
        paddingLeft: '15px',
        marginBottom: '10px',
        position: 'relative',
    },
};

export default style;